export type PermissionType = 'MENU_PARENT' | 'MENU_ITEM' | 'ACTION';

export const PermissionTypeEnum = {
    MenuParent: 'MENU_PARENT' as PermissionType,
    MenuItem: 'MENU_ITEM' as PermissionType,
    Action: 'ACTION' as PermissionType,
};
